import { useContext, useEffect } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { LegalTexts } from "../components/LegalTexts";
import { t } from "../i18n";
import PhoneLabel from "../components/PhoneLabel";
import { useWizardNavigation } from "../hooks/useWizardNavigation";
import { TrustMessage } from "../components/TrustMessage";
import { Icon } from "../components/Icon";
import { MONTH_NAMES_SHORT } from "../utils/helpers";

export const BookingEnd = () => {
	const { nextPage, previousPage } = useWizardNavigation();

	return (
		<>
			<Header />
			<Content />
			<Footer
				nextPage={nextPage}
				previousPage={previousPage}
				clearOnBack={[
					"insurance",
					"noInsurance",
					"email",
					"name",
					"privacy_policy_2",
				]}
			/>
		</>
	);
};

const Content = () => {
	const {
		flow,
		data,
		setData,
		companies,
		setCompanies,
		isTransitioning,
		errors,
		validateForm,
		brands,
		models,
		setModels,
	} = useContext(AppContext);

	const formatDate = (date) => {
		const [year, month, day] = String(date).split("T")[0].split("-");
		return `${Number(day)} de ${MONTH_NAMES_SHORT[Number(month) - 1]}. ${year}`;
	};

	useEffect(() => {
		validateForm();
	}, [
		validateForm,
		data.plate,
		data.brand,
		data.model,
		data.insurance,
		data.noInsurance,
		data.email,
		data.name,
		data.phone,
		data.privacy_policy_2,
	]);

	useEffect(() => {
		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		if (data.brand && data.locator) {
			fetch(
				`${apiUrl}/query/models?brand=${data.brand}&locator=${data.locator}`,
				options,
			)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setModels(newData.models);
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}
	}, [data.brand, data.locator, setModels]);

	useEffect(() => {
		let apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		if (data.locator) {
			fetch(`${apiUrl}/query/companies?locator=${data.locator}`, options)
				.then((res) => res.json())
				.then((newData) => {
					if (newData.result === "ok") {
						setCompanies(newData.companies);
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					controller.abort();
				});
		}
	}, [data.locator, setCompanies]);

	return (
		<div className="Wrapper">
			<TrustMessage
				iconName="check"
				text="No tendrás que llamar a tu aseguradora. Nosotros gestionamos el proceso por ti."
			/>

			<div
				className={
					"content booking_end kensei_03" +
					(isTransitioning ? " fade-in" : "")
				}
			>
				<div className="content_booking_form">
					<div className="booking_form_title">
						{/* <h2>
							<strong>
								{t(
									"Solo necesitamos estos datos para confirmar tu cita",
								)}
							</strong>
						</h2> */}
						<span>
							{t("Confirma tu cita para tu vehículo:")}
							<strong>
								{" " + data.brand + " " + data.model}
							</strong>
							{/* {t(" en el taller ")}
							<strong>{data.centerName}</strong> */}
						</span>
					</div>

					<div className="booking_form_summary">
						{/* <h2 className="booking_form_summary_h2">Datos para tu cita</h2> */}
						<div className="booking_form_appointment">
							{/* <div className="booking_form_car">
								<Icon name="car" />
								<h2>{data.brand} - {data.model}</h2>
							</div> */}

							<div className="booking_form_location">
								<Icon name="location" />
								<div className="booking_form_details">
									<h2>{data.centerName}</h2>
									<p>{data.centerAddress}</p>
								</div>
							</div>

							<div className="booking_form_date">
								<Icon name="calendar" />
								<h2>
									{formatDate(data.date)} - {data.startTime}
								</h2>
							</div>
						</div>
					</div>

					<div className="booking_form_content">
						<div className="booking_form_vehicle">
							<p>{t("Datos del vehículo")}</p>
							<form>
								<label>
									<strong>{t("Matrícula")}</strong>
									<input
										type="text"
										className={
											errors.plate ? "field-error" : ""
										}
										defaultValue={data ? data.plate : ""}
										onChange={(e) =>
											setData((prev) => ({
												...prev,
												plate: e.target.value,
											}))
										}
									/>
									{errors.plate && (
										<span className="error">
											{errors.plate}
										</span>
									)}
								</label>
								<label>
									<strong>{t("Marca vehículo")}</strong>
									<select
										className={
											errors.brand ? "field-error" : ""
										}
										value={data?.brand || ""}
										onChange={(e) =>
											setData((prev) => ({
												...prev,
												brand: e.target.value,
												model: "",
											}))
										}
									>
										<option value="">
											{t("Selecciona marca")}
										</option>
										{data?.brand &&
											!brands.includes(data.brand) && (
												<option value={data.brand}>
													{data.brand}
												</option>
											)}
										{brands &&
											brands.map((brand) => (
												<option
													key={brand}
													value={brand}
												>
													{brand}
												</option>
											))}
									</select>
									{errors.brand && (
										<span className="error">
											{errors.brand}
										</span>
									)}
								</label>
								<label>
									<strong>{t("Modelo")}</strong>
									<select
										className={
											errors.model ? "field-error" : ""
										}
										value={data?.model || ""}
										disabled={!data.brand}
										onChange={(e) =>
											setData((prev) => ({
												...prev,
												model: e.target.value,
											}))
										}
									>
										<option value="">
											{t("Selecciona modelo")}
										</option>
										{data?.model &&
											!models.includes(data.model) && (
												<option value={data.model}>
													{data.model}
												</option>
											)}
										{models &&
											models.map((model, index) => (
												<option
													key={index}
													value={model}
												>
													{model}
												</option>
											))}
									</select>
									{errors.model && (
										<span className="error">
											{errors.model}
										</span>
									)}
								</label>
								{flow === "web" && (
									<>
										<label>
											<strong>{t("Aseguradora")}</strong>
											<select
												className={
													errors.insurance
														? "field-error"
														: ""
												}
												value={data?.insurance || ""}
												onChange={(e) =>
													setData((prev) => ({
														...prev,
														insurance:
															e.target.value,
													}))
												}
												disabled={data?.noInsurance}
											>
												<option value="">
													{t("Elige tu seguro")}
												</option>
												{companies &&
													companies.map(
														(company, index) => (
															<option
																key={index}
																value={company}
															>
																{company}
															</option>
														),
													)}
											</select>
											{errors.insurance && (
												<span className="error">
													{errors.insurance}
												</span>
											)}
										</label>
										<label className="no_insurance">
											<input
												type="checkbox"
												checked={
													!!(data && data.noInsurance)
												}
												onChange={(e) =>
													setData((prev) => ({
														...prev,
														noInsurance:
															e.target.checked,
														insurance: e.target
															.checked
															? ""
															: prev.insurance,
													}))
												}
											/>
											{t("No tengo aseguradora")}
										</label>
									</>
								)}
							</form>
						</div>

						<div className="booking_form_user">
							<p>{t("Tus datos")}</p>
							<form>
								<label>
									<strong>{t("Email")}</strong>
									<input
										type="email"
										className={
											errors.email ? "field-error" : ""
										}
										defaultValue={data ? data.email : ""}
										onChange={(e) =>
											setData((prev) => ({
												...prev,
												email: e.target.value,
											}))
										}
									/>
									{errors.email && (
										<span className="error">
											{errors.email}
										</span>
									)}
								</label>
								<label>
									<strong>{t("Nombre y Apellidos")}</strong>
									<input
										type="text"
										className={
											errors.name ? "field-error" : ""
										}
										defaultValue={data ? data.name : ""}
										onChange={(e) =>
											setData((prev) => ({
												...prev,
												name: e.target.value,
											}))
										}
									/>
									{errors.name && (
										<span className="error">
											{errors.name}
										</span>
									)}
								</label>
								<PhoneLabel	/>
								<label className="privacy_policy">
									<div className="privacy_policy_content">
										<input
											type="checkbox"
											checked={
												!!(
													data &&
													data.privacy_policy_2
												)
											}
											onChange={(e) =>
												setData((prev) => ({
													...prev,
													privacy_policy_2:
														e.target.checked,
												}))
											}
										/>
										<span className="link">
											{t("Acepto la")}{" "}
											<a
												href="https://www.ralarsa.com/es/privacidad/"
												target="_blank"
												rel="noopener noreferrer"
											>
												{t("política de privacidad")}
											</a>
										</span>
									</div>
									{errors.privacy_policy_2 && (
										<span className="error">
											{errors.privacy_policy_2}
										</span>
									)}
								</label>
							</form>
						</div>
						<LegalTexts />
					</div>
				</div>
			</div>
		</div>
	);
};
